// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homepage-footers-images {
   /* background-color: rgb(1, 18, 35); */
   background-color: rgb(17, 29, 47);
   /* padding: 20px 20px 100px 20px; */
   padding: 20px;
   color: #ffff;
}
.footer-hompage-image {
    display: flex;
    justify-content: center;
    align-items: center;
    inline-size: 150px;
    block-size: auto;
    margin-block-start: 0px;
}

.homepage-footer-hr {
    border: 2px solid white;
    margin-block-start: 10px;
    margin-block-end: 10px;
    inline-size: 100%;
}

.footer-social {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 40px;
    /* margin-block-end: 20px; */
    padding-inline-start: 80px;
}

.footer-social-icons {
    padding-inline-end: 70px;
}

.social-icon,
.homepage-social-icon-link {
    margin-inline-start: 10px;
    inline-size: 35px;
    block-size: 35px;
    color: rgb(5, 38, 89);
    border-radius: 50%;
    padding: 8px;
    background-color: rgb(255, 255, 255);
    gap: 10px;
}

.social-icon:hover,
.homepage-social-icon-link:hover {
    transform: scale(1.1);
}

.homepage-social-icon-link {
    color: rgb(5, 38, 89) !important;
    text-decoration: none;
    background-color: rgb(255, 255, 255);
}
.homepage-footer-copyrightp {
    font-size: 16px;
    font-weight: 400;
}

/* background */
.backgroundimages-1 {
    background: linear-gradient(to bottom, rgb(244, 247, 252), rgb(102, 101, 101));
}

.bottom-contact-bar {
  inline-size: 100%;
  background-color: #000000;
  color: white;
  font-family: 'Segoe UI', sans-serif;
  font-size: 14px;
  position: fixed;
  inset-block-end: 0;
  z-index: 999;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
}

.bottom-bar-marquee-wrappers {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 8px 40px;
}

.bottom-bar-top {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
}

.bottom-bar-top span {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-block-end: 5px;
}

.bottom-bar-marquee-wrapper {
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  block-size: 30px;
  background-color: #052659;
  border-radius: 5px;
  padding-inline-start: 10px;
}

.bottom-bar-marquee {
  display: inline-block;
  padding-inline-start: 100%;
  animation: scroll-left 20s linear infinite;
  font-weight: 600;
  color: #fff;
}

@keyframes scroll-left {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}

.bottom-bar-marquee a {
  color: #ffd700;
  text-decoration: underline;
  font-weight: bold;
}

@media (min-width: 320px) and (max-width: 480px) {
    .homepage-footers-images {
        margin-block-start: -10px;
     }
    .footer-hompage-image {
        inline-size: 150px;
        block-size: auto;
        margin-inline-start: 0;
        margin-block-start: 20px;
    }
    .homepage-footer-hr {
        margin: 10px auto;
        inline-size: 100%;
    }
    .footer-social {
        flex-direction: column;
        align-items: center;
        padding-block-start: 20px;
        padding-inline-start: 0;
    }
    .footer-social-icons {
        margin-inline-start: auto;
        margin-inline-end: auto;
        padding: 0px;
    }
    .social-icon,
    .homepage-social-icon-link {
        inline-size: 30px;
        block-size: 30px;
        margin: 5px;
        padding: 6px;
    }

    /*background  */
    .backgroundimages-1 {
        block-size: auto;
        inline-size: auto;
    }
    .backgroundcolorin-images {
        inline-size: auto;
        block-size: auto;
        border-radius: 0px;
        padding: 0px 0px 20px 0px;
        margin: 0px -10px 0px -10px;
    }
    .backgroundcolorin-images-ul {
        flex-direction: column;
        margin-inline-start: auto;
        margin-inline-end: auto;
        padding: 0px;
    }
    .backgroundcolorin-images-ul ul {
        text-align: center;
        padding: 20px 10px 10px 10px;
    }
    .backgroundcolorin-experience-learn-h1{
        font-size: 28px;
        line-height: 1.5rem;
        text-align: center;
        padding: 0px;
    }
    .backgroundcolorin-experience-p{
        font-size: 1.2rem;
        line-height: 2;
        text-align: center;
        padding: 0px 20px 0px 20px;
    }
    .buttonget-join-now-btn {
        inline-size: 160px;
        block-size: 36px;
        font-size: 16px;
        border-radius: 0px;
        margin-inline-end: 35px;
    }
    .buttonget-join-now-btn-link {
        padding-block-start: 20px;
    }
    .learnerspage-page-banner10-card{
        padding: 10px 40px;
        align-items: center;
    }
    .learnerspage-page-banner10-image {
        inline-size: 0px;
        block-size: 0px;
    }
    .footer-content-background-color {
        padding: 20px 0px 20px 0px;
    }
    .students-footer {
        flex-direction: column;
    }
    .footer-content-background-color-huebits {
        font-size: 1.6rem;
        margin: 0px 10px 0px 20px;
    }
    .footer-content-background-color-students {
        margin-inline-start: 20px;
    }
    .footer-content-background-color-companies {
        margin-inline-start: 20px;
    }
}

@media (min-width: 481px) and (max-width: 1023px){
    .homepage-footer {
        padding: 40px 0px 0px 0px;
        justify-content: center;
    }
    .footer-hompage-image {
        inline-size: 222px;
        block-size: 54px;
        margin-inline-start: auto;
        margin-inline-end: auto;
        margin-block-start: 50px;
        padding: 0px 40px 0px 0px;
    }
    .homepage-footer-hr {
        margin: 10px auto;
        inline-size: 100%;
    }
    .footer-social {
        justify-content: start;
        align-items: start;
        padding-block-start: 10px;
        padding-block-end: 10px;
    }

    /* background */
    .backgroundcolorin-images {
        block-size: auto;
        padding: 40px 14px 40px 0px;
    }
    .backgroundcolorin-images-ul {
        justify-content: center;
        text-align: center;
        margin-inline-start: 0px;
    }
    .backgroundcolorin-images-ul ul {
        padding-block-start: 20px;
    }
    .headway-images,
    .headway-imageses {
        justify-content: start;
        align-items: start;
        margin-inline-start: auto;
        margin-inline-end: auto;
    }
    .headway-image {
        inline-size: 350px;
        block-size: 350px;
    }
}

@media (min-width: 1024px) and (max-width: 1500px) {
.learnerspage-page-banner10-image {
    inline-size: 450px;
    block-size: 350px;
}
}`, "",{"version":3,"sources":["webpack://./src/styles/footer.css"],"names":[],"mappings":"AAAA;GACG,sCAAsC;GACtC,iCAAiC;GACjC,mCAAmC;GACnC,aAAa;GACb,YAAY;AACf;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,oCAAoC;IACpC,SAAS;AACb;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,oCAAoC;AACxC;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI,8EAA8E;AAClF;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;IACI;QACI,yBAAyB;KAC5B;IACD;QACI,kBAAkB;QAClB,gBAAgB;QAChB,sBAAsB;QACtB,wBAAwB;IAC5B;IACA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,yBAAyB;QACzB,uBAAuB;IAC3B;IACA;QACI,yBAAyB;QACzB,uBAAuB;QACvB,YAAY;IAChB;IACA;;QAEI,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;QACX,YAAY;IAChB;;IAEA,eAAe;IACf;QACI,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,2BAA2B;IAC/B;IACA;QACI,sBAAsB;QACtB,yBAAyB;QACzB,uBAAuB;QACvB,YAAY;IAChB;IACA;QACI,kBAAkB;QAClB,4BAA4B;IAChC;IACA;QACI,eAAe;QACf,mBAAmB;QACnB,kBAAkB;QAClB,YAAY;IAChB;IACA;QACI,iBAAiB;QACjB,cAAc;QACd,kBAAkB;QAClB,0BAA0B;IAC9B;IACA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,kBAAkB;QAClB,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,gBAAgB;QAChB,eAAe;IACnB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,iBAAiB;QACjB,yBAAyB;IAC7B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,uBAAuB;IAC3B;IACA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,yBAAyB;QACzB,uBAAuB;QACvB,wBAAwB;QACxB,yBAAyB;IAC7B;IACA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA,eAAe;IACf;QACI,gBAAgB;QAChB,2BAA2B;IAC/B;IACA;QACI,uBAAuB;QACvB,kBAAkB;QAClB,wBAAwB;IAC5B;IACA;QACI,yBAAyB;IAC7B;IACA;;QAEI,sBAAsB;QACtB,kBAAkB;QAClB,yBAAyB;QACzB,uBAAuB;IAC3B;IACA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;AACJ;;AAEA;AACA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA","sourcesContent":[".homepage-footers-images {\n   /* background-color: rgb(1, 18, 35); */\n   background-color: rgb(17, 29, 47);\n   /* padding: 20px 20px 100px 20px; */\n   padding: 20px;\n   color: #ffff;\n}\n.footer-hompage-image {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    inline-size: 150px;\n    block-size: auto;\n    margin-block-start: 0px;\n}\n\n.homepage-footer-hr {\n    border: 2px solid white;\n    margin-block-start: 10px;\n    margin-block-end: 10px;\n    inline-size: 100%;\n}\n\n.footer-social {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    gap: 40px;\n    /* margin-block-end: 20px; */\n    padding-inline-start: 80px;\n}\n\n.footer-social-icons {\n    padding-inline-end: 70px;\n}\n\n.social-icon,\n.homepage-social-icon-link {\n    margin-inline-start: 10px;\n    inline-size: 35px;\n    block-size: 35px;\n    color: rgb(5, 38, 89);\n    border-radius: 50%;\n    padding: 8px;\n    background-color: rgb(255, 255, 255);\n    gap: 10px;\n}\n\n.social-icon:hover,\n.homepage-social-icon-link:hover {\n    transform: scale(1.1);\n}\n\n.homepage-social-icon-link {\n    color: rgb(5, 38, 89) !important;\n    text-decoration: none;\n    background-color: rgb(255, 255, 255);\n}\n.homepage-footer-copyrightp {\n    font-size: 16px;\n    font-weight: 400;\n}\n\n/* background */\n.backgroundimages-1 {\n    background: linear-gradient(to bottom, rgb(244, 247, 252), rgb(102, 101, 101));\n}\n\n.bottom-contact-bar {\n  inline-size: 100%;\n  background-color: #000000;\n  color: white;\n  font-family: 'Segoe UI', sans-serif;\n  font-size: 14px;\n  position: fixed;\n  inset-block-end: 0;\n  z-index: 999;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);\n}\n\n.bottom-bar-marquee-wrappers {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  padding: 8px 40px;\n}\n\n.bottom-bar-top {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  align-items: center;\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.bottom-bar-top span {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-block-end: 5px;\n}\n\n.bottom-bar-marquee-wrapper {\n  overflow: hidden;\n  white-space: nowrap;\n  position: relative;\n  block-size: 30px;\n  background-color: #052659;\n  border-radius: 5px;\n  padding-inline-start: 10px;\n}\n\n.bottom-bar-marquee {\n  display: inline-block;\n  padding-inline-start: 100%;\n  animation: scroll-left 20s linear infinite;\n  font-weight: 600;\n  color: #fff;\n}\n\n@keyframes scroll-left {\n  0% {\n    transform: translateX(0%);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n.bottom-bar-marquee a {\n  color: #ffd700;\n  text-decoration: underline;\n  font-weight: bold;\n}\n\n@media (min-width: 320px) and (max-width: 480px) {\n    .homepage-footers-images {\n        margin-block-start: -10px;\n     }\n    .footer-hompage-image {\n        inline-size: 150px;\n        block-size: auto;\n        margin-inline-start: 0;\n        margin-block-start: 20px;\n    }\n    .homepage-footer-hr {\n        margin: 10px auto;\n        inline-size: 100%;\n    }\n    .footer-social {\n        flex-direction: column;\n        align-items: center;\n        padding-block-start: 20px;\n        padding-inline-start: 0;\n    }\n    .footer-social-icons {\n        margin-inline-start: auto;\n        margin-inline-end: auto;\n        padding: 0px;\n    }\n    .social-icon,\n    .homepage-social-icon-link {\n        inline-size: 30px;\n        block-size: 30px;\n        margin: 5px;\n        padding: 6px;\n    }\n\n    /*background  */\n    .backgroundimages-1 {\n        block-size: auto;\n        inline-size: auto;\n    }\n    .backgroundcolorin-images {\n        inline-size: auto;\n        block-size: auto;\n        border-radius: 0px;\n        padding: 0px 0px 20px 0px;\n        margin: 0px -10px 0px -10px;\n    }\n    .backgroundcolorin-images-ul {\n        flex-direction: column;\n        margin-inline-start: auto;\n        margin-inline-end: auto;\n        padding: 0px;\n    }\n    .backgroundcolorin-images-ul ul {\n        text-align: center;\n        padding: 20px 10px 10px 10px;\n    }\n    .backgroundcolorin-experience-learn-h1{\n        font-size: 28px;\n        line-height: 1.5rem;\n        text-align: center;\n        padding: 0px;\n    }\n    .backgroundcolorin-experience-p{\n        font-size: 1.2rem;\n        line-height: 2;\n        text-align: center;\n        padding: 0px 20px 0px 20px;\n    }\n    .buttonget-join-now-btn {\n        inline-size: 160px;\n        block-size: 36px;\n        font-size: 16px;\n        border-radius: 0px;\n        margin-inline-end: 35px;\n    }\n    .buttonget-join-now-btn-link {\n        padding-block-start: 20px;\n    }\n    .learnerspage-page-banner10-card{\n        padding: 10px 40px;\n        align-items: center;\n    }\n    .learnerspage-page-banner10-image {\n        inline-size: 0px;\n        block-size: 0px;\n    }\n    .footer-content-background-color {\n        padding: 20px 0px 20px 0px;\n    }\n    .students-footer {\n        flex-direction: column;\n    }\n    .footer-content-background-color-huebits {\n        font-size: 1.6rem;\n        margin: 0px 10px 0px 20px;\n    }\n    .footer-content-background-color-students {\n        margin-inline-start: 20px;\n    }\n    .footer-content-background-color-companies {\n        margin-inline-start: 20px;\n    }\n}\n\n@media (min-width: 481px) and (max-width: 1023px){\n    .homepage-footer {\n        padding: 40px 0px 0px 0px;\n        justify-content: center;\n    }\n    .footer-hompage-image {\n        inline-size: 222px;\n        block-size: 54px;\n        margin-inline-start: auto;\n        margin-inline-end: auto;\n        margin-block-start: 50px;\n        padding: 0px 40px 0px 0px;\n    }\n    .homepage-footer-hr {\n        margin: 10px auto;\n        inline-size: 100%;\n    }\n    .footer-social {\n        justify-content: start;\n        align-items: start;\n        padding-block-start: 10px;\n        padding-block-end: 10px;\n    }\n\n    /* background */\n    .backgroundcolorin-images {\n        block-size: auto;\n        padding: 40px 14px 40px 0px;\n    }\n    .backgroundcolorin-images-ul {\n        justify-content: center;\n        text-align: center;\n        margin-inline-start: 0px;\n    }\n    .backgroundcolorin-images-ul ul {\n        padding-block-start: 20px;\n    }\n    .headway-images,\n    .headway-imageses {\n        justify-content: start;\n        align-items: start;\n        margin-inline-start: auto;\n        margin-inline-end: auto;\n    }\n    .headway-image {\n        inline-size: 350px;\n        block-size: 350px;\n    }\n}\n\n@media (min-width: 1024px) and (max-width: 1500px) {\n.learnerspage-page-banner10-image {\n    inline-size: 450px;\n    block-size: 350px;\n}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
